import { Delete, Edit } from '@mui/icons-material';
import {
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { IInventoryOption } from '../../../../Interfaces/IInventoryOption';
import { ILegalTransactionRelationshipRealEstate } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { ILegalTransactionRelationshipRealEstateInventoryOption } from '../../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstateInventoryOption';
import { CreateOrUpdateRealEstateInventoryOptionDialog } from './CreateOrUpdateRealEstateInventoryOptionDialog';

interface IProps {
  formValues: ILegalTransactionRelationshipRealEstate;
  setFormValues: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationshipRealEstate>
  >;
  inventoryOptions: IInventoryOption[];
}

export const RealEstateInventoryOptions: React.FC<IProps> = ({
  formValues: { idRealEstate, InventoryOptionArray },
  setFormValues,
  inventoryOptions,
}) => {
  const [isMount, setIsMount] = useState(false);
  const [selectedInventoryOption, setSelectedInventoryOption] =
    useState<ILegalTransactionRelationshipRealEstateInventoryOption>();

  return (
    <>
      <Typography variant='h5' sx={{ mt: 2, mb: 1 }}>
        Anlagen
        <br />
        <Typography>
          Neben dem eigentlichen Grundstück können ebenfalls{' '}
          <u>Inventar und Anlagen mitverkauft</u> werden. Bitte erfassen Sie
          sämtliches Inventar (Einbauküche, Möbel etc.) und Anlagen
          (Fotovoltaikanlagen, Bootssteg etc.), welche mitverkauft werden.
        </Typography>
      </Typography>

      <Button
        variant='contained'
        sx={{ float: 'right' }}
        onClick={() => setIsMount(true)}
      >
        Hinzufügen
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Anzahl</TableCell>
            <TableCell>Bezeichnung</TableCell>
            <TableCell>Beschreibung</TableCell>
            <TableCell>Aktionen</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {InventoryOptionArray.map((o, i) => (
            <TableRow key={i}>
              <TableCell>{o.Amount}</TableCell>
              <TableCell>{o.Title}</TableCell>
              <TableCell>{o.Description ?? '-'}</TableCell>
              <TableCell>
                <IconButton
                  onClick={() => {
                    setSelectedInventoryOption(o);
                    setIsMount(true);
                  }}
                >
                  <Edit />
                </IconButton>
                <IconButton
                  onClick={() =>
                    setFormValues(prev => ({
                      ...prev,
                      InventoryOptionArray: [
                        ...prev.InventoryOptionArray.filter(
                          y => y.idInventoryOption !== o.idInventoryOption
                        ),
                      ],
                    }))
                  }
                >
                  <Delete />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {isMount && (
        <CreateOrUpdateRealEstateInventoryOptionDialog
          realEstateId={idRealEstate}
          selectedInventoryOption={selectedInventoryOption}
          inventoryOptions={inventoryOptions}
          setFormValues={setFormValues}
          unmount={() => {
            setIsMount(false);
            setSelectedInventoryOption(undefined);
          }}
        />
      )}
    </>
  );
};
